<script setup lang="ts">
defineProps<{
  fill?: string
}>()
</script>

<template>
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="#19413E"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M17 0H13V7.12436L10.4641 2.73205C9.91182 1.77547 8.68864 1.44772 7.73205 2C6.77547 2.55228 6.44772 3.77547 7 4.73205L9.69615 9.40192L3 5.5359L1 9L7.9282 13H2C0.895431 13 0 13.8954 0 15C0 16.1046 0.89543 17 2 17H7.12436L1 20.5359L3 24L9.40193 20.3038L6.5359 25.268C5.98361 26.2245 6.31136 27.4477 7.26795 28C8.22453 28.5523 9.44771 28.2245 10 27.268L13 22.0718V30H17V22.0526L20 27.2487C20.5523 28.2053 21.7755 28.533 22.732 27.9808C23.6886 27.4285 24.0164 26.2053 23.4641 25.2487L20.6244 20.3301L26.9808 24L28.9808 20.5359L22.8564 17H28C29.1046 17 30 16.1046 30 15C30 13.8954 29.1046 13 28 13H22.0526L28.9808 9L26.9808 5.5359L20.3301 9.37564L23 4.75129C23.5523 3.7947 23.2245 2.57152 22.268 2.01924C21.3114 1.46695 20.0882 1.7947 19.5359 2.75129L17 7.14359V0Z"
      :fill="fill"
    />
  </svg>
</template>
